import React from "react";
import { Helmet } from "react-helmet-async";
import PropTypes from "prop-types";
import { hreflangsForLocale, isHiddenHost } from "core-web/utils/multimarket";

const absoluteUri = (uri) => (uri.toLowerCase().indexOf("//") === 0 ? `https:${uri}` : uri);

const LanguageLinks = ({ links }) => {
    // A market that is not open to the public yet must not be announced to search engines —
    // wallmek.co.uk answers with a basic-auth challenge, so its alternate would point at a 401.
    const usable = links.filter(({ uri }) => !!uri && !isHiddenHost(uri));

    // One <link> per hreflang value; the mapping (including which market is x-default) lives in
    // HREFLANGS_BY_LOCALE so it is not derived from the application locale.
    const alternates = usable.flatMap(({ uri, locale }) =>
        hreflangsForLocale(locale).map((hrefLang) => (
            <link key={`${locale}-${hrefLang}`} href={absoluteUri(uri)} rel="alternate" hrefLang={hrefLang} />
        )),
    );

    return <Helmet>{alternates}</Helmet>;
};

LanguageLinks.propTypes = {
    links: PropTypes.array.isRequired,
};

export default LanguageLinks;
